import { Label, FormFeedback } from "reactstrap"
import "./DynamicField.css"
import InputField from "./InputField"
import QuillEditor from "./QuillEditor"

const DynamicField = ({
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  invalid = false,
  feedback = "",
  required = false,
  ...props
}) => {
  const commonProps = {
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    invalid,
    feedback,
    ...props,
  }

  // Handle Quill editor changes
  const handleQuillChange = content => {
    if (props.setFieldValue) {
      props.setFieldValue(name, content)
    } else {
      const event = {
        target: { name, value: content, type: "richtext" },
      }
      onChange(event)
    }
  }

  const handleQuillBlur = () => {
    if (onBlur) {
      const event = { target: { name } }
      onBlur(event)
    }
  }

  // Rich Text Field
  if (type === "richtext") {
    return (
      <div className="mb-3">
        {label && (
          <Label className="form-label" for={name}>
            {label}
            {required && <span className="text-danger"> *</span>}
          </Label>
        )}

        <div
          className={`quill-wrapper ${invalid ? "is-invalid" : ""}`}
          style={{
            border: invalid ? "0.5px solid var(--bs-form-invalid-border-color)" : "0.5px solid #ced4da",
            borderRadius: "0.375rem",
            overflow: "hidden",
          }}
        >
          <QuillEditor
            {...commonProps}
            onChange={handleQuillChange}
            onBlur={handleQuillBlur}
          />
        </div>
         {invalid && feedback && (
        <FormFeedback style={{ display: "block" }}>{feedback}</FormFeedback>
      )}
      </div>
    )
  }

  // Normal Input Field
  return (
    <div className="mb-3">
      {label && (
        <Label className="form-label" for={name}>
          {label}
          {required && <span className="text-danger"> *</span>}
        </Label>
      )}
      <InputField type={type} {...commonProps} />
      {invalid && feedback && (
        <FormFeedback style={{ display: "block" }}>{feedback}</FormFeedback>
      )}
    </div>
  )
}

export default DynamicField
